import React from 'react';
import Content from '@/components/foundations/content';
import * as styles from './solution.module.scss';

const SolutionContent: React.FC = () => {
  return (
    <div className={styles.oSolution__message}>
      <h2>
        <strong>低コスト・短納期で解決</strong>のお手伝いをします！
      </h2>
      <p>プロダクトのアイデアや構想を、頭の中や資料で精査しきることは、経験のある担当者でも難しいものです。</p>
      <p>
        そんな時は、プロトタイピングで検証してみませんか？
        <strong>まずは必要な部分を最小限で作ってみることで、見えづらかった問題点や、新たな可能性を浮き彫りにする</strong>
        アプローチをおすすめしています。
      </p>
      <p>1,500件を超える経験と実績に基づいた、PIVOT流のプロトタイピングを是非お試しください。</p>
    </div>
  );
};

const Solution: React.FC = () => {
  return (
    <Content
      className={{ wrapper: styles.oSolution, inner: styles.lContent__inner }}
      intersection={{ visible: styles.visible, standby: styles.standby }}
    >
      <SolutionContent />
    </Content>
  );
};

export default Solution;
